import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import CustomStore from 'devextreme/data/custom_store';
import { NTECH_API } from './../app.api';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid } from './../app.config';
import { DxDataGridModule, DxDataGridComponent } from 'devextreme-angular';
import { Router } from '@angular/router';
import { ProtocoloMotivoService } from '../protocolo-motivo/protocolo-motivo.service';
import { listaEstadosAndamento } from './../shared/listas-parametros';

@Component({
  selector: 'ntc-protocolos',
  templateUrl: './protocolos.component.html',
  styleUrls: ['./protocolos.component.css']
})
export class ProtocolosComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridProtocolo = [];
  protocolo = null;
  alturaGrid = null;
  listaProtocoloMotivo = [];
  listaEstadoAndamento = listaEstadosAndamento;

  editOptionsGridProtocolo = {
    mode: GridConfig.gridMode, // form GridConfig.gridMode
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Usuario Sistema',
      showTitle: true
    }
  };

  constructor(
    @Inject(Http) http: Http,
    private protocoloMotivoService: ProtocoloMotivoService,
    private router: Router
  ) {

    this.protocolo = new CustomStore({
      remove: function (key) {
        return http.delete(`${NTECH_API}/protocolo/${encodeURIComponent(key.Id)}`).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/protocolo/`)
            .toPromise()
            .then(response => {
              const retorno = response.json();
              let axUltimoEstado = null;
              // pegar ultimo estado andamento
              if ( (retorno !== undefined ) && ( retorno.length !== undefined ) && (retorno.length > 0)  ) {
                for ( let i = 0 ; i < retorno.length ; i ++ ) {
                  // verificar se existe registros de estado andamento
                  if ( (retorno[i].ProtocoloEstados !== undefined) && ( retorno[i].ProtocoloEstados !== null ) &&
                  (retorno[i].ProtocoloEstados.length !== undefined) && (retorno[i].ProtocoloEstados.length > 0)
                  ) {
                    retorno[i].IdUltimoEstadoAndamento = 0;
                    axUltimoEstado = null;
                    for ( let j = 0 ; j < retorno[i].ProtocoloEstados.length ; j ++) {
                      if ( axUltimoEstado === null ) {
                        axUltimoEstado = {
                          IdEstadosAndamento: retorno[i].ProtocoloEstados[j].IdEstadosAndamento,
                          DtHrProtocoloEstado: retorno[i].ProtocoloEstados[j].DtHrProtocoloEstado
                        };
                        retorno[i].IdUltimoEstadoAndamento = retorno[i].ProtocoloEstados[j].IdEstadosAndamento;
                      } else if (
                        (new Date(retorno[i].ProtocoloEstados[j].DtHrProtocoloEstado).getTime()) >=
                        (new Date(axUltimoEstado.DtHrProtocoloEstado).getTime())
                      ) {
                        axUltimoEstado = {
                          IdEstadosAndamento: retorno[i].ProtocoloEstados[j].IdEstadosAndamento,
                          DtHrProtocoloEstado: retorno[i].ProtocoloEstados[j].DtHrProtocoloEstado
                        };
                        retorno[i].IdUltimoEstadoAndamento = retorno[i].ProtocoloEstados[j].IdEstadosAndamento;
                      }
                    }
                    axUltimoEstado = null;
                  }
                }
              }
              return retorno;
            })
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  montaForm = function() {
    this.colunasGridProtocolo = [
      {
        dataField: 'Id',
        dataType: 'string',
        caption: 'ID',
        editorOptions: { disabled: true }
      },
      {
        dataField: 'IdContrato',
        dataType: 'string',
        caption: 'Contrato'
      },
      {
        dataField: 'IdProtocoloMotivo',
        caption: 'Motivo',
        lookup: {
            dataSource: this.listaProtocoloMotivo,
            displayExpr: 'DescricaoProtocoloMotivo',
            valueExpr: 'Id'
        }
      },
      {
        dataField: 'IdUltimoEstadoAndamento',
        caption: 'Estado do Andamento',
        lookup: {
            dataSource: this.listaEstadoAndamento,
            displayExpr: 'DescricaoEstadosAndamento',
            valueExpr: 'Id'
        }
      },
    ];
  };

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onEditingStart(e) {
    this.router.navigate([`/protocolo/${e.data.Id}`]);
  }

  onInitNewRow(e) {
    this.router.navigate(['/protocolo']);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();

    this.protocoloMotivoService.getProtocoloMotivos().subscribe(
      protocoloMotivos => {
        this.listaProtocoloMotivo = protocoloMotivos;
        this.montaForm();
      }, erro => {
        this.montaForm();
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/protocolos/protocolos.component.ts